export const LocalStorageKeys = {
  ExtranetUserName: 'ls.ExtranetUserName',
  ExtranetLastUsedUserName: 'ls.ExtranetLastUsedUserName',
  ExtranetUser: 'ls.ExtranetUser',
  ExtranetAuth_GoBack_UserName: 'ls.ExtranetAuth_GoBack_UserName',
  ExtranetAuth_GoBack_AccessToken: 'ls.ExtranetAuth_GoBack_AccessToken',
};

export const CookieKeys = {
  ExtranetAccessToken: 'ExtranetAccessToken',
};
